import {type CardTypeEnum} from '@colonist/game-states'
import {type GameModeTranslationKeyContext} from '@colonist/i18n'
import {type BaseGameModeData} from '@colonist/shared-types'
import {type StateCreator} from 'zustand'

export interface GameModeSlice {
    gameMode: {
        activeResourceCardTypes: CardTypeEnum[]
        activeDevelopmentAndProgressCardTypes: CardTypeEnum[]
        /**
         * @deprecated Use useUIGameTranslationContext instead
         */
        translationKeyContext: GameModeTranslationKeyContext
    }
}

export interface GameModeSliceProps {
    initialGameModeData: BaseGameModeData
}

export const createGameModeSlice = ({
    initialGameModeData,
}: GameModeSliceProps): StateCreator<GameModeSlice> => (set, get) => ({
    gameMode: {
        activeResourceCardTypes: initialGameModeData.activeResourceCardTypes,
        activeDevelopmentAndProgressCardTypes: initialGameModeData.activeDevelopmentCardTypes,
        /**
         * @deprecated Use useUIGameTranslationContext instead
         */
        translationKeyContext: initialGameModeData.translationKeyContext,
    },
})
